<script setup lang="ts">
useHead({
  title: "Шарунстор — политика конфиденциальности.",
  meta: [
    {
      name: "description",
      content:
        "Ознакомьтесь с политикой обработки персональных данных в Шарунстор",
    },
    {
      name: "keywords",
      content: "политика обработки персональных данных в Шарунстор",
    },
  ],
});
import Cookie from "~/components/Section/Cookie.vue";
import Breadcrumbs from "~/components/Section/Breadcrumbs.vue";
import Footer from "~/components/System/Footer.vue";

const breadcrumbs = ref([
  { title: "Главная", url: "/" },
  { title: "Политика конфиденциальности" },
]);
</script>

<template>
  <main class="main">
    <section class="content">
      <Breadcrumbs :breadcrumbs="breadcrumbs" />
      <div class="container">
        <h1>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h1>
        <p>Редакция от «17» февраля 2026 г.</p>

        <hr />

        <h2>1. Общие положения</h2>

        <p>
          1.1. Настоящая Политика конфиденциальности определяет порядок
          обработки и защиты персональных данных Индивидуальным
          предпринимателем:
        </p>

        <p>
          <strong>Шарун Максим Алексеевич</strong><br />
          ИНН 230902778202<br />
          ОГРНИП 322237500087501<br />
          (далее — «Оператор»).
        </p>

        <p>
          1.2. Политика разработана в соответствии с Федеральным законом РФ №
          152-ФЗ «О персональных данных», Федеральным законом № 149-ФЗ «Об
          информации, информационных технологиях и защите информации» и иными
          нормативными актами Российской Федерации.
        </p>

        <p>
          1.3. Использование сайта Шарунстор означает согласие Пользователя с
          настоящей Политикой.
        </p>

        <hr />

        <h2>2. Термины</h2>

        <ul>
          <li>
            <strong>Персональные данные</strong> — любая информация, относящаяся
            к прямо или косвенно определенному физическому лицу.
          </li>
          <li>
            <strong>Обработка</strong> — любое действие с персональными данными
            (сбор, запись, хранение, использование, передача, удаление и т.д.).
          </li>
          <li>
            <strong>Пользователь</strong> — лицо, использующее сайт и сервисы
            Шарунстор.
          </li>
        </ul>

        <hr />

        <h2>3. Персональные данные, которые обрабатываются</h2>

        <h3>3.1. Данные, предоставляемые Пользователем:</h3>
        <ul>
          <li>ФИО;</li>
          <li>номер телефона;</li>
          <li>адрес электронной почты;</li>
          <li>адрес доставки;</li>
          <li>
            платежные реквизиты (в пределах, необходимых для исполнения
            договора);
          </li>
          <li>иные сведения, предоставленные добровольно.</li>
        </ul>

        <h3>3.2. Данные, собираемые автоматически:</h3>
        <ul>
          <li>IP-адрес;</li>
          <li>cookie;</li>
          <li>тип устройства;</li>
          <li>тип браузера;</li>
          <li>данные о действиях на сайте;</li>
          <li>технические журналы сервера.</li>
        </ul>

        <h3>3.3. Данные для аналитики и маркетинга:</h3>
        <ul>
          <li>история заказов;</li>
          <li>предпочтения;</li>
          <li>взаимодействие с рассылками.</li>
        </ul>

        <p>
          Оператор не осуществляет обработку специальных категорий персональных
          данных.
        </p>

        <hr />

        <h2>4. Цели обработки персональных данных</h2>

        <ul>
          <li>заключение и исполнение договоров;</li>
          <li>оформление и доставка заказов;</li>
          <li>обработка возвратов;</li>
          <li>предоставление доступа к личному кабинету;</li>
          <li>осуществление подписки;</li>
          <li>направление уведомлений;</li>
          <li>продвижение товаров и услуг (при наличии согласия);</li>
          <li>выполнение требований законодательства РФ;</li>
          <li>защита законных интересов Оператора.</li>
        </ul>

        <hr />

        <h2>5. Правовые основания обработки</h2>

        <p>Обработка персональных данных осуществляется на основании:</p>

        <ul>
          <li>согласия субъекта персональных данных;</li>
          <li>исполнения договора;</li>
          <li>требований законодательства РФ;</li>
          <li>законных интересов Оператора.</li>
        </ul>

        <hr />

        <h2>6. Передача персональных данных третьим лицам</h2>

        <p>6.1. Оператор вправе передавать персональные данные:</p>

        <ul>
          <li>платежным системам (в том числе Яндекс Пэй);</li>
          <li>логистическим компаниям;</li>
          <li>партнерским продавцам (если заказ оформлен у них);</li>
          <li>государственным органам по законному требованию.</li>
        </ul>

        <p>
          6.2. Передача осуществляется в объеме, необходимом для исполнения
          обязательств.
        </p>

        <p>
          6.3. Оператор не продает и не передает персональные данные третьим
          лицам в коммерческих целях.
        </p>

        <hr />

        <h2>7. Срок хранения данных</h2>

        <p>
          7.1. Персональные данные хранятся не дольше, чем это необходимо для
          достижения целей обработки.
        </p>

        <p>
          7.2. По достижении целей обработки данные подлежат удалению либо
          обезличиванию, если иное не предусмотрено законодательством РФ.
        </p>

        <hr />

        <h2>8. Права Пользователя</h2>

        <ul>
          <li>получать информацию об обработке своих данных;</li>
          <li>требовать уточнения данных;</li>
          <li>требовать удаления данных;</li>
          <li>отзывать согласие на обработку;</li>
          <li>
            обращаться в уполномоченные органы по защите прав субъектов
            персональных данных.
          </li>
        </ul>

        <hr />

        <h2>9. Меры по защите персональных данных</h2>

        <p>
          9.1. Оператор принимает необходимые организационные и технические меры
          для защиты данных от неправомерного доступа, изменения, раскрытия или
          уничтожения.
        </p>

        <p>
          9.2. Доступ к персональным данным предоставляется только
          уполномоченным лицам.
        </p>

        <p>
          9.3. Оператор не несет ответственности за действия третьих лиц при
          отсутствии вины Оператора.
        </p>

        <hr />

        <h2>10. Использование файлов Cookie</h2>

        <p>
          10.1. Сайт использует cookie для обеспечения корректной работы,
          аналитики и персонализации.
        </p>

        <p>10.2. Пользователь может отключить cookie в настройках браузера.</p>

        <hr />

        <h2>11. Трансграничная передача</h2>

        <p>
          В случае использования зарубежных сервисов возможна трансграничная
          передача персональных данных в соответствии с требованиями
          законодательства РФ.
        </p>

        <hr />

        <h2>12. Изменение Политики</h2>

        <p>
          Оператор вправе изменять настоящую Политику. Новая редакция вступает в
          силу с момента публикации на сайте.
        </p>

        <hr />

        <h2>13. Контактная информация</h2>

        <p>
          ИП Шарун Максим Алексеевич<br />
          ИНН 230902778202<br />
          ОГРНИП 322237500087501<br />
          E-mail: info@maxsharun.ru
        </p>
      </div>
    </section>
  </main>

  <Cookie />
</template>

<style scoped></style>
